// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"a7e19082","171":"f149ebf5","401":"e4f57d71","423":"3503741c","436":"559b9800","565":"30219b4e","575":"dd1b632c","721":"c9b73d48","901":"5437a67e","938":"3d8f54b4"}[chunkId] + ".chunk.js";
};